import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
import { wrappedTranslations } from '../../../translations/wrapped';

interface ComebackStoryCardProps {
    comebackWins: number;
    reverseSweeps: number;
    lang: 'en' | 'fr' | 'de' | 'it';
}

const ComebackStoryCard: React.FC<ComebackStoryCardProps> = ({ comebackWins, reverseSweeps, lang }) => {
    const t = wrappedTranslations[lang];
    return (
        <div className="h-full w-full flex flex-col items-center justify-center text-center p-6">
            <div className="max-w-4xl w-full flex flex-col items-center">
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.2, type: "spring" }}
                >
                    <TrendingUp className="w-20 h-20 md:w-32 md:h-32 mb-8 mx-auto text-[#1C7AD6]" />
                </motion.div>

                <motion.h2
                    className="text-3xl sm:text-4xl md:text-4xl font-bold mb-4 text-gray-900 tracking-tight whitespace-nowrap"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4 }}
                >
                    {t.comebackKing}
                </motion.h2>

                <motion.p
                    className="text-base md:text-lg text-gray-600 mb-12 px-4"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                >
                    {t.neverGaveUp}
                </motion.p>

                <motion.div
                    className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 shadow-lg w-full max-w-3xl"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6 }}
                >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                        <div className="text-center p-6 md:p-8 bg-gray-50 rounded-2xl border border-gray-200">
                            <div className="text-5xl md:text-7xl font-bold text-emerald-600 mb-2 md:mb-4 break-words">{comebackWins}</div>
                            <div className="text-xs md:text-sm text-gray-700 uppercase tracking-wider leading-tight px-2">{t.winsAfterLosing1stSet}</div>
                        </div>
                        <div className="text-center p-6 md:p-8 bg-gray-50 rounded-2xl border border-gray-200">
                            <div className="text-5xl md:text-7xl font-bold text-[#1C7AD6] mb-2 md:mb-4 break-words">{reverseSweeps}</div>
                            <div className="text-xs md:text-sm text-gray-700 uppercase tracking-wider leading-tight px-2">{t.reverseSweeps}<br /><span className="text-[10px] md:text-xs text-gray-500 normal-case tracking-normal">{t.reverseSweepsDetail}</span></div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default ComebackStoryCard;
